import React, { useContext } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard';

import authContext from '../context/authContext/authContext';
import successHandle from '../utils/successHandle';
import getDomain from '../utils/getDomain';

const domain = getDomain();

const GdTokens = () => {
  const { user } = useContext(authContext);

  const referralLink = `${domain}/register?referId=${user?._id}`

  const onCopy = () => {
    const message = "Referral Id copied! you can share"
    successHandle(message)
  }

  const onShare = () => {
    window.open(referralLink, "_blank")
  }

  return (
    <div className='container mt-5'>
      <div className='px-2 px-md-4 px-lg-5 py-4'>
        <div className='section-title'>
          <p>GD Tokens</p>
          <div className=''>Invite users through your referral link, Every successful registration made through your shared link gives you instant reward points automatically..</div>
        </div>

        <div className='row refer-for-gt'>
          <div className='col-md-5 mb-4'>
            <div className='how-this-workning'>
              <label className='mb-2 fw-600'>How to Earn Referral Reward</label>
              <div className='ml-2'>
                <div className='mb-2'>
                  <div>➡️ Refer to your Friends or Family</div>
                  <small className='ml-4' style={{ fontSize: 12 }}>Share your unique referral link with friends or family..</small>
                </div>
                <div className='mb-2'>
                  <div>➡️ Open Free Demat Account</div>
                  <small className='ml-4' style={{ fontSize: 12 }}>Your friend opens a demat account using your referral link.</small>
                </div>
                <div className='mb-2'>
                  <div>➡️ Earn Referral Reward 🎉 </div>
                  <small className='ml-4' style={{ fontSize: 12 }}>Once the account is activated, you will receive reward.</small>
                </div>
              </div>
            </div>
          </div>

          <div className='col-md-7 mb-4'>
            <div className=''>
              <label className='mb-2 fw-500'>Referral Link:</label>
              <div className='d-flex flex-wrap gap-2'>
                <input type="text" className="form-control" style={{ minWidth: 0, flex: '1 1 200px' }} value={referralLink} readOnly />
                <div className='d-flex gap-1'>
                  <button onClick={onShare} className="btn btn-outline-secondary"><i className='fa fa-share' /></button>
                  <CopyToClipboard text={user?._id} onCopy={onCopy}>
                    <button className="btn btn-outline-secondary"><i className='fa fa-copy' /></button>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GdTokens;